<template>
  <div class="company-warning">
    <div class="company-warning__description description">
      <span class="description__main-message">Сайт не опубликован.</span> Опубликуйте свой сайт,
      чтобы он стал доступен другим пользователям.
    </div>
    <button
      type="button"
      class="company-warning__btn"
      @click="publish"
    >
      Опубликовать
    </button>
  </div>
</template>

<script setup lang="ts">
const { publish } = useCompanyStore();
</script>

<style scoped lang="scss">
@use '@/styles/company-warning';
</style>
